export default "__VITE_ASSET__184847b0__"